import React from "react";

import styles from "./ErrorFallback.module.scss";

const ErrorFallback = ({ error }) => (
  <div className={styles.container}>
    <div className={styles.innerContainer}>
      <span className={styles.header}>Something went wrong</span>
      <span className={styles.message}>{error?.message}</span>
      <button
        type="button"
        className={styles.button}
        onClick={() => window.location.reload()}
      >
        Try again
      </button>
    </div>
  </div>
);

export default ErrorFallback;
